import { application } from "./application"

import YtPreviewController from "./yt_preview_controller"
application.register("yt-preview", YtPreviewController)

import SegmentPreviewController from "./segment_preview_controller"
application.register("segment-preview", SegmentPreviewController)

import ThemeLanguageController from "./theme_language_controller"
application.register("theme-language", ThemeLanguageController)